module.exports = __webpack_public_path__ + "assets/img/block-hover-1ae36c11.png";